import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-end-item-allocation-methods',
  templateUrl: './end-item-allocation-methods.component.html',
  styleUrls: ['./end-item-allocation-methods.component.css']
})
export class EndItemAllocationMethodsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.EndItemAllocationMethods.columns;
    this.data = this.report.EndItemAllocationMethods.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.EndItemAllocationMethods.data;
    const gridInstance = this.gridContext.getInstance('EndItemAllocationMethods');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/end-item-allocation-methods/end-item-allocation-methods.component.ts